import { jsx as e } from "react/jsx-runtime";
import { R as l, I as g } from "../../../index-DR85PwK2.js";
import { c as u } from "../../../clsx-OuTLNxxd.js";
import { useState as m, useEffect as d } from "react";
const p = "_small_ghhu4_36", y = "_indicator_ghhu4_40", f = "_primary_ghhu4_49", w = "_secondary_ghhu4_55", b = "_tertiary_ghhu4_61", x = "_success_ghhu4_67", I = "_error_ghhu4_79", r = {
  "progress-bar": "_progress-bar_ghhu4_29",
  small: p,
  indicator: y,
  "full-width": "_full-width_ghhu4_46",
  primary: f,
  secondary: w,
  tertiary: b,
  success: x,
  "eco-green": "_eco-green_ghhu4_73",
  error: I,
  "dialog-overlay-show": "_dialog-overlay-show_ghhu4_1",
  "dialog-content-show": "_dialog-content-show_ghhu4_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_ghhu4_1"
}, j = ({ value: s = 0, color: o = "primary", size: t, isFullWidth: a, ariaLabel: c }) => {
  const [_, i] = m(0), n = u(
    r["progress-bar"],
    t && r[t],
    o && r[o],
    a && r["full-width"]
  );
  return d(() => {
    const h = setTimeout(() => i(s), 500);
    return () => clearTimeout(h);
  }, [s]), /* @__PURE__ */ e(l, { className: n, "aria-label": c, children: /* @__PURE__ */ e(g, { className: r.indicator, style: { transform: `translateX(-${100 - _}%)` } }) });
};
export {
  j as ProgressBar
};
